import React, { useState } from 'react';
import api from '../../utils/api';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Plus, Trash2 } from 'lucide-react';

export const CompagnieTab = ({ compagnie, onReload }) => {
  const [newCompagnia, setNewCompagnia] = useState('');

  const addCompagnia = async () => {
    if (!newCompagnia.trim()) return;
    try { await api.post('/prestiti/compagnie', { nome: newCompagnia.trim() }); setNewCompagnia(''); onReload(); toast.success('Compagnia aggiunta'); } catch {}
  };
  const deleteCompagnia = async (id) => {
    try { await api.delete(`/prestiti/compagnie/${id}`); onReload(); } catch {}
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-5 max-w-lg">
      <h3 className="font-semibold text-slate-800 mb-4">Compagnie Finanziarie</h3>
      <div className="flex gap-2 mb-4">
        <Input value={newCompagnia} onChange={e => setNewCompagnia(e.target.value)} placeholder="Nome compagnia..." data-testid="input-nuova-compagnia" />
        <Button onClick={addCompagnia} size="sm" className="bg-slate-800 hover:bg-slate-700 text-white" data-testid="add-compagnia-btn"><Plus size={14} /></Button>
      </div>
      <div className="space-y-1.5">
        {compagnie.length === 0 ? <p className="text-sm text-slate-400">Nessuna compagnia. Aggiungine una.</p> :
          compagnie.map(c => (
            <div key={c.id} className="flex items-center justify-between px-3 py-2 bg-slate-50 rounded-lg" data-testid={`compagnia-${c.id}`}>
              <span className="text-sm font-medium text-slate-700">{c.nome}</span>
              <button onClick={() => deleteCompagnia(c.id)} className="text-slate-400 hover:text-red-500 p-1"><Trash2 size={13} /></button>
            </div>
          ))
        }
      </div>
    </div>
  );
};
